import moment from "moment-timezone";
import { DATE_TIME_WITH_ZONE_FORMAT } from "../constants";
import { fetchImageForJSPDF, formatCurrency, hexToGrayscale } from "../functions";
import { Attachment, ConfigStateForPDF, QuoteSliceInterface } from "../types";

const getInitials = (name: string) => {
    return name
        .split(" ")
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
};

export const quoteTitle = (title1: string, title2: string) => {
    return `
    <div style="width: 100%; display: flex; justify-content:space-between; font-size:12px; padding-left:20px; padding-right:20px; solid #ccc;">
            <p style="font-size:10px;">${title1}</p>
            <p style="font-size:10px;">${title2}</p>
    </div>
    `
};

const correspondanceBuilder = (quote: QuoteSliceInterface, drawLine: boolean, onlyCoverPage?: boolean) => {

    let correspondance = ``;

    const { soldBy, soldTo, shipFrom, shipTo } = quote.correspondance;

    const address = [soldBy, soldTo, shipFrom, shipTo].filter((s) => s.include);

    if (address.length > 0) {
        if (drawLine) {
            correspondance += `
            <div class="${onlyCoverPage ? "fixed" : "absolute"} right-0 bottom-0 left-0 p-3 pl-6">
                <hr class="mb-4 text-gray-300 pr-3" />
            `;
        } else {
            correspondance += `<div class="mt-12 p-3 pl-6">`;
        };

        correspondance += `<div class="flex gap-1">`;

        if (soldBy.include) {

            const { name, emailId, phoneNumber, address } = soldBy.address;

            correspondance += `<div class=" w-1/4">
            
            <h6 class="text-sm font-semibold mb-2">Quoted By:</h6>`;

            if (name.include) {
                correspondance += `<p class="text-sm">${name.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (address.include) {
                correspondance += `<p class="text-sm">${address.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (emailId.include) {
                correspondance += `<p class="text-sm">${emailId.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (phoneNumber.include) {
                correspondance += `<p class="text-sm">${phoneNumber.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            correspondance += '</div>'
        };

        if (soldTo.include) {
            const { name, emailId, phoneNumber, address } = soldTo.address;

            correspondance += `<div class=" w-1/4">
            
            <h6 class="text-sm font-semibold mb-2">Quoted To:</h6>`;

            if (name.include) {
                correspondance += `<p class="text-sm">${name.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (address.include) {
                correspondance += `<p class="text-sm">${address.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (emailId.include) {
                correspondance += `<p class="text-sm">${emailId.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (phoneNumber.include) {
                correspondance += `<p class="text-sm">${phoneNumber.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            correspondance += '</div>'
        };

        if (shipFrom.include) {
            const { name, emailId, phoneNumber, address } = shipFrom.address;

            correspondance += `<div class=" w-1/4">
            
            <h6 class="text-sm font-semibold mb-2">Shipped From:</h6>`;

            if (name.include) {
                correspondance += `<p class="text-sm">${name.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (address.include) {
                correspondance += `<p class="text-sm">${address.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (emailId.include) {
                correspondance += `<p class="text-sm">${emailId.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (phoneNumber.include) {
                correspondance += `<p class="text-sm">${phoneNumber.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            correspondance += '</div>'
        };

        if (shipTo.include) {
            const { name, emailId, phoneNumber, address } = shipTo.address;

            correspondance += `<div class=" w-1/4">
            
            <h6 class="text-sm font-semibold mb-2">Shipped To:</h6>`;

            if (name.include) {
                correspondance += `<p class="text-sm">${name.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (address.include) {
                correspondance += `<p class="text-sm">${address.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (emailId.include) {
                correspondance += `<p class="text-sm">${emailId.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            if (phoneNumber.include) {
                correspondance += `<p class="text-sm">${phoneNumber.value?.trim()?.replaceAll('\n', '<br>')}</p>`;
            };

            correspondance += '</div>'
        };

        correspondance += '</div> </div>';
    }

    return correspondance;
};

const coverPage = async (quote: QuoteSliceInterface, onlyCoverPage: boolean) => {

    let coverPage = `<div class="page-break relative pt-4">`;

    const cover_page_config = quote.cover_page_config;

    const url = ((cover_page_config?.logo?.src as Attachment)?.url || cover_page_config?.attachments?.[0]?.url) as string;

    const logoData = { fileDetails: quote.cover_page_config.logo.src || cover_page_config?.attachments?.[0], url };

    const cover_page_header = cover_page_config.heading;

    if (cover_page_config.include_heading && cover_page_header) {
        coverPage += `<div class="absolute top-[25vh] left-0 right-0"><h1 class="w-full text-center text-xl font-semibold whitespace-pre-line">${cover_page_header}</h1></div>`;
    };

    if (cover_page_config.logo.isActive && logoData.url) {

        const imageWidth = cover_page_config?.logo?.width || 100;
        const imageHeight = cover_page_config?.logo?.height || 100;

        let x = cover_page_config.logo.horizontal;
        let y = cover_page_config.logo.vertical;

        try {
            const imageURL = await fetchImageForJSPDF(logoData.url);
            coverPage += `
            <div class="absolute" style="transform: translate(${x}vw, ${y}vh) translate(-50%, -50%)">
                <img src="${imageURL}" alt="image" width="${imageWidth}px" height="${imageHeight}px" style="object-fit: contain; max-width: ${imageWidth}px; max-height: ${imageHeight}px;" />
            </div>
            `;
        } catch (error) {
            console.error("Unable to load the image", JSON.stringify(error));
        }
    };

    coverPage += `${correspondanceBuilder(quote, true, onlyCoverPage)}</div>`;

    return coverPage;
};

export const buildQuoteReportHTML = async (quote: QuoteSliceInterface, configState: Partial<ConfigStateForPDF>, onlyCoverPage?: boolean): Promise<string> => {

    const timeZone = quote.time_zone ?? moment.tz.guess();

    const base_currency = quote?.currency?.value ?? "USD";

    const header_color = configState?.tableHeaderColor || "#d1c4e9";
    const useMBFormatter = configState?.useMBFormatter ?? false;

    let body = ``;

    if (quote.cover_page_config.include_cover_page) {
        body += await coverPage(quote, onlyCoverPage);
    }

    if (onlyCoverPage) {
        return Promise.resolve(body);
    };

    if (configState.include_revision_table) {
        body += `<div class="page-break relative pt-4">
            <div class=" px-6 mt-[-20px]">
                <h2 class=" font-semibold">Revision History</h2>

                <div>
                    <table class="table-fixed mt-5 p-3 pl-6">
                        <thead>
                             <tr class="bg-gray-100 border-b-1 border-black">
                                <th class="pl-2 py-2 text-sm text-left break-all w-[5rem]">Rev. No.</th>
                                <th class="pl-2 py-2 text-sm text-left break-all w-[7rem]">Date</th>
                                <th class="pl-2 py-2 text-sm text-left break-all w-[30rem]">Description</th>
                                ${quote.revision_info?.created_by?.include ? `<th class="pl-2 py-2 text-sm text-left break-all w-[7rem]">Created By</th>` : ''}
                                ${quote.revision_info?.referred_by?.include ? `<th class="pl-2 py-2 text-sm text-left break-all w-[7rem]">Reviewed By</th>` : ''}
                                ${quote.revision_info?.approved_by?.include ? `<th class="pl-2 py-2 text-sm text-left break-all w-[7rem]">Approved By</th>` : ''}
                            </tr>
                        </thead>
                        <tbody>

                            ${quote.revision_info ? `
                                <tr class="bg-gray-50">
                                    <td class="px-2 py-2 text-sm text-left break-all w-[5rem]">${quote.version ?? ''}</td>
                                    <td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${quote.revision_info.date ? moment(quote.revision_info.date).tz(timeZone).format('DD-MMM-YYYY') : "N/A"}</td>
                                    <td class="px-2 py-2 text-sm text-left break-all w-[30rem]">${quote.revision_info.description ?? ''}</td>
                                    ${quote.revision_info?.created_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${getInitials(quote.revision_info.created_by?.value?.label ?? "")}</td>` : ''}
                                    ${quote.revision_info?.referred_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${getInitials(quote.revision_info.referred_by?.value?.label ?? "")}</td>` : ''}
                                    ${quote.revision_info?.approved_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${getInitials(quote.revision_info.approved_by?.value?.label ?? "")}</td>` : ''}
                                </tr>
                            `: ``}
                            ${quote?.revision_info?.history?.map((history, idx) => {
                                const version_info = history.version_info;
            return `
                                <tr class="bg-gray-50">
                                    <td class="px-2 py-2 text-sm text-left break-all w-[5rem]">${history.version ?? ''}</td>
                                    <td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${version_info?.date_time ? moment(version_info.date_time ?? '').tz(timeZone).format('DD-MMM-YYYY') : 'N/A'}</td>
                                    <td class="px-2 py-2 text-sm text-left break-all w-[30rem]">${version_info?.description ?? ''}</td>
                                    ${quote.revision_info?.created_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${version_info?.creator ? `${getInitials(version_info.creator.user_name)}` : 'N/A'}</td>` : ''}
                                    ${quote.revision_info?.referred_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${version_info?.revisor ? `${getInitials(version_info.revisor.user_name)}` : 'N/A'}</td>` : ''}
                                    ${quote.revision_info?.approved_by?.include ? `<td class="px-2 py-2 text-sm text-left break-all w-[7rem]">${version_info?.approver ? `${getInitials(version_info.approver.user_name)}` : 'N/A'}</td>` : ''}
                                </tr>
                        `
        })?.join('') ?? ''}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>`;
    };

    if (quote.cover_letter.include) {
        body += `<div class="page-break relative ">
        ${quote.cover_page_config.include_cover_page ? '' : correspondanceBuilder(quote, false)}
        <div class=" px-6 pt-4">`;

        if (quote.include_cover_letter_from) {
            const fromAddress = quote.cover_letter.fromAddress?.trim();

            body += `
            <div>
                <h6 class="text-sm font-semibold mb-1">From</h6>
                <p class="text-sm">${fromAddress.replaceAll('\n', '<br>')}</p>
            </div>
            `;
        };

        if (quote.include_cover_letter_subject) {
            body += `<h6 class="text-sm font-semibold mt-4">Subject: ${(quote.cover_letter.subject ?? "")?.trim()}</h6>`
        };

        if (quote.cover_letter.content?.trim()) {
            body += `<p class="text-sm mt-3">${quote.cover_letter.content?.trim()?.replaceAll('\n', '<br>')}</p>`
        };

        if (quote.cover_letter.regards?.trim()) {
            body += `<h6 class="text-sm font-semibold mt-4">${quote.cover_letter.regards?.trim()}</h6>`
        };

        if (quote.cover_letter.attachments?.length) {

            let contentUrl = quote.cover_letter.attachments?.[0]?.url;

            await fetchImageForJSPDF(contentUrl).then((contentBytes: string) => {
                body += `<img class=" mt-1" src = "${contentBytes}" alt = "signature" style="width: 150px; height: 50px"  />`;
            }).catch(async (error: any) => {
                console.error(`Error loading content image on preview: ${error}`);
            });
        };

        if (quote.cover_letter.name?.trim()) {
            body += `<p class="text-sm">${quote.cover_letter.name?.trim()?.replaceAll('\n', '<br>')}</p>`
        };

        if (quote.cover_letter.designation?.trim()) {
            body += `<p class="text-sm">${quote.cover_letter.designation?.trim()?.replaceAll('\n', '<br>')}</p>`
        };

        body += `
        </div></div>`;

    };

    body += `<div class="page-break relative pt-4"><div class=" px-6 mt-[-20px]">`;

    const contents = quote.contents?.filter((t) => t.heading?.trim() && t.notes?.trim()) ?? [];

    if (contents.length > 0) {
        body += `<div>`;
        contents.forEach((content, index) => {
            body += `<div>
                <h3 class=" font-semibold mt-4">${(index + 1)}. ${content.heading}</h3>
                
                <div class="text-sm mt-4 suneditor">
                    ${content.notes}
                </div>
            </div>`;
        });
        body += `</div>`;
    };

    body += `<div> <h2 class=" font-semibold ${contents.length > 0 ? 'mb-6' : ''}">List of Parts included in the quote</h2>`;

    body += `
    <div>

    <table class="table-fixed mt-5 p-3 pl-6">
        <thead>
            <tr class="bg-[${header_color}] text-[${hexToGrayscale(header_color) > 150 ? "#000000" : "#FFFFFF"}] ">
                <th class="pl-2 py-2 text-sm text-left break-all w-[9rem]">Part/Item No.</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[14rem]">Description</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[10rem]">Unit Price</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[7rem]">Discount(%)</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[6rem]">Quantity</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[10rem]">Sale Price (${base_currency})</th>
                <th class="pl-2 py-2 text-sm text-left break-all w-[8rem]">Delivery Time</th>
            </tr>
        </thead>

        <tbody>
            ${quote.customQuote ? quote.quote_custom_item_details?.map((q, idx) => {
        return `
                <tr class="${idx % 2 === 0 ? 'bg-gray-50' : 'bg-gray-100'}">
                    <td class="px-2 py-2 text-sm">${q.part_number}</td>
                    <td class="px-2 py-2 text-sm">${q.description}</td>
                    <td class="px-2 py-2 text-sm">${formatCurrency(q.unitCost ?? 0, base_currency, useMBFormatter)}</td>
                    <td class="px-2 py-2 text-sm">${q.discount ?? 0}</td>
                    <td class="px-2 py-2 text-sm">${q.quantity ?? 1}</td>
                    <td class="px-2 py-2 text-sm">${formatCurrency(q.totalCost ?? 0, base_currency, useMBFormatter)}</td>
                    <td class="px-2 py-2 text-sm">${q.leadTime?.trim()}</td>
                </tr>
                `
    })?.join('') ?? `` : ``}

            ${!quote.customQuote ? quote.quote_item_details?.map((q, idx) => {
        return `
                <tr class="${idx % 2 === 0 ? 'bg-gray-50' : 'bg-gray-100'}">
                    <td class="px-2 py-2 text-sm">${q.partNumber}</td>
                    <td class="px-2 py-2 text-sm">${q.description}</td>
                    <td class="px-2 py-2 text-sm">${formatCurrency(q.unitCost ?? 0, base_currency, useMBFormatter)}</td>
                    <td class="px-2 py-2 text-sm">${q.discount ?? 0}</td>
                    <td class="px-2 py-2 text-sm">${q.quantity ?? 1}</td>
                    <td class="px-2 py-2 text-sm">${formatCurrency(q.totalCost ?? 0, base_currency, useMBFormatter)}</td>
                    <td class="px-2 py-2 text-sm">${q.leadTime?.trim()}</td>
                </tr>
        `
    })?.join('') ?? `` : ``}
        </tbody>
    </table>
    </div>
    `;

    const tax_details = quote?.tax_details?.filter((t) => t?.value) ?? [];

    body += `
    <div>
        <table class="table-fixed mt-5 p-3 pl-6">
            <thead id="thead">
                <tr class=" border-b-2 border-black bg-[${header_color}] text-[${hexToGrayscale(header_color) > 150 ? "#000000" : "#FFFFFF"}]">
                    <td class="px-2 py-2 text-md text-left break-all w-[20rem]">Total Cost ${tax_details.length > 0 ? `(before tax)` : ``}</td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[3rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[10rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[7rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[6rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[8rem]"></td>
                    <td class="px-2 py-2 text-sm text-right break-all w-[10rem]">${formatCurrency(quote?.total_quote_item_price ?? 0, base_currency, useMBFormatter)}</td>
                </tr>
            <tbody></tbody>
            </thead>
        </table>
    </div>
    `;

    if (tax_details.length > 0) {
        body += `<h2 class=" font-semibold mt-3 ">Taxes</h2>`;

        body += `
     <div>
        <table class="table-fixed mt-5 p-3 pl-6">
            <thead></thead>
            <tbody>
                ${tax_details?.map((q, idx) => {
            return `
                    <tr class="${idx % 2 === 0 ? 'bg-gray-50' : 'bg-gray-100'}">
                       <td class="px-2 py-2 text-sm text-left break-all w-[9rem]">N/A</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[14rem]">${(q?.description ?? "")?.trim()}</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[10rem]">N/A</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[7rem]">N/A</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[6rem]">${q?.value ?? 0}%</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[10rem]">N/A</td>
                       <td class="px-2 py-2 text-sm text-left break-all w-[8rem]">N/A</td>
                    </tr>
            `
        })?.join('') ?? ''}
            </tbody>
        </table>
    </div>
        `;

        body += `
    <div>
        <table class="table-fixed mt-5 p-3 pl-6">
            <thead id="thead">
                <tr class=" border-b-2 border-black">
                    <td class="pr-2 text-md text-left break-all w-[14rem]">Total Tax</td>
                    <td class="pr-2 text-sm text-left break-all w-[9rem]"></td>
                    <td class="pr-2 text-sm text-left break-all w-[10rem]"></td>
                    <td class="pr-2 text-sm text-left break-all w-[7rem]"></td>
                    <td class="pr-2 text-sm text-left break-all w-[6rem]"></td>
                    <td class="pr-2 text-sm text-left break-all w-[8rem]"></td>
                    <td class="pr-2 text-sm text-right break-all w-[10rem]">${formatCurrency(quote?.total_quote_tax_price ?? 0, base_currency, useMBFormatter)}</td>
                </tr>

            <tbody></tbody>
            </thead>
        </table>
    </div>
        `;

        body += `
    <div>
        <table class="table-fixed mt-5 p-3 pl-6">
            <thead id="thead">
                <tr class=" border-b-2 border-black bg-[${header_color}] text-[${hexToGrayscale(header_color) > 150 ? "#000000" : "#FFFFFF"}]">
                    <td class="px-2 py-2 text-md text-left break-all w-[14rem]">Total Cost (after tax)</td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[9rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[10rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[7rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[6rem]"></td>
                    <td class="px-2 py-2 text-sm text-left break-all w-[8rem]"></td>
                    <td class="px-2 py-2 text-sm text-right break-all w-[10rem]">${formatCurrency(quote?.total_quote_price ?? 0, base_currency, useMBFormatter)}</td>
                </tr>

            <tbody></tbody>
            </thead>
        </table>
    </div>
        `;
    }

    body += `</div>`;

    const terms_and_conditions = quote.terms_and_conditions?.filter((t) => t.heading?.trim() && t.notes?.trim()) ?? [];

    if (terms_and_conditions.length > 0) {
        body += `<div><h2 class=" font-semibold mt-6">Terms and Conditions:</h2>`;
        terms_and_conditions.forEach((content, index) => {
            body += `
                <h3 class=" font-semibold mt-4">${(index + 1)}. ${content.heading}</h3>

                <div class="text-sm mt-4 suneditor">
                    ${content.notes}
                </div>
            `;
        });
        body += '</div>'
    };

    body += `
    </div>
    `;


    return Promise.resolve(body)
};